import { Pipe, PipeTransform } from '@angular/core';
import { ObservationsAndRecommandationsPluginService } from './observationsandrecommandations-plugin.service';

@Pipe({
    name: 'prioritiespipe',
    standalone: false
})
export class PrioritiesPipe implements PipeTransform {
  public priorities: any;

  constructor(private service: ObservationsAndRecommandationsPluginService) {
    this.priorities = this.service.getPriorities();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.priorities);
  }
}
